import { Button, Divider, TextField } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

import { formatIsoToDate } from '@utils/date';

import s from './FlowEditActionBar.module.css';

type FlowEditActionBarProps = {
  flowName: string;
  flowLastUpdatedAt: string;
  isLoading: boolean;
  isDisabled: boolean;
  onFlowNameChange: (name: string) => void;
  onFlowSave: () => void;
};

function FlowEditActionBar({
  flowName,
  flowLastUpdatedAt,
  isLoading,
  isDisabled,
  onFlowNameChange,
  onFlowSave,
}: FlowEditActionBarProps) {
  return (
    <div className={s.flowEditActionBarContainer}>
      <p className={s.flowEditActionBarTile}>
        Last published at: {formatIsoToDate(flowLastUpdatedAt)}
      </p>
      <Divider />
      <div className={s.flowEditActionBarActions}>
        <TextField
          size="small"
          value={flowName}
          name="flow-name"
          label="Flow name"
          className={s.flowEditActionBarNameInput}
          onChange={(e) => onFlowNameChange(e.target.value)}
          required
        />
        <Button
          variant="contained"
          disabled={isDisabled || isLoading}
          loading={isLoading}
          className={s.flowEditActionBarSaveButton}
          onClick={onFlowSave}>
          <SaveOutlinedIcon fontSize="small" />
          <p className={s.buttonText}>Save</p>
        </Button>
      </div>
    </div>
  );
}

export default FlowEditActionBar;
